module.exports = __webpack_public_path__ + "static/media/milano.58de521b.png";